import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's stock scales. The design system adds
 * named type sizes, two radii, two container widths and three animations
 * (see src/index.css), and an unregistered `text-title` is classified as a
 * COLOUR — so `cn('text-title text-ink')` used to collapse to `text-ink` and
 * drop the size. Registering the scales here keeps the conflict resolution
 * honest in both directions: sizes beat sizes, colours beat colours, and a
 * caller's className still wins over a primitive's default.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['caption', 'label', 'body', 'body-lg', 'title', 'heading', 'display'],
      radius: ['control', 'surface'],
      container: ['page', 'form'],
      animate: ['fade-in', 'pop-in', 'pop-in-shift', 'shimmer'],
    },
  },
})

/**
 * Merge class names, resolving Tailwind conflicts in favour of the last one.
 *
 * @param {...any} inputs - Class names, arrays, or conditional objects
 * @returns {string} The merged class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
